module.exports = __webpack_public_path__ + "img/@logo_skplanet@3x.c1dd54ed.png";